import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { TwoFactor } from '@/features/auth/two-factor'

const searchSchema = z.object({
  redirect: z.string().optional(),
})

export const Route = createFileRoute('/(auth)/two-factor')({
  component: TwoFactor,
  validateSearch: searchSchema,
})

